module.exports = __webpack_public_path__ + "static/media/navets.2290fd13.svg";